/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

import Grid from '@mui/material/Grid';
import React from 'react';
import { useAppSelector } from 'src/js/redux/hooks/redux';
import onCourseLogoDark from '../../../images/IshOncourseLogoBlack.svg';
import { makeAppStyles } from '../../styles/makeStyles';

const useStyles = makeAppStyles()((theme) => ({
  root: {
    width: '265px',
    height: '100vh',
    padding: theme.spacing(4),
    backgroundColor: theme.tabList.listContainer.backgroundColor,
    position: 'fixed',
    left: 0,
    top: 0,
    bottom: 0,
  },
  listContainer: {
    flexDirection: 'column',
    flex: 1,
    textAlign: 'center',
    '& > img': {
      maxWidth: 200
    },
    display: 'flex',
    height: '100%'
  }
}));

const LeftMenu = ((
  {
    children
  }
) => {
  const { classes, cx } = useStyles();
  const customLogo = useAppSelector(state => state.systemProperties.customLogoBlack)

  return (
    <Grid container className={classes.root}>
      <div className={cx('relative',
        classes.listContainer)}
      >
        <img
          src={customLogo || onCourseLogoDark}
          alt="Logo"
        />
        {children}
      </div>
    </Grid>
  );
});

export default LeftMenu;
